import confirmTemplate from '@/plugins/confirm/ConfirmTemplate.vue'

/* eslint-disable prefer-promise-reject-errors */
export default {
  install(Vue, options) {
    let confirmInstance = null
    Vue.prototype.$confirm = (config) => {
      if (config) confirmTemplate.props = {}
      let ConfirmConstructor = Vue.extend(Object.assign({ vuetify: options.vuetify }, confirmTemplate))
      return new Promise((resolve, reject) => {
        if (confirmInstance) return
        confirmInstance = new ConfirmConstructor({
          el: document.createElement('div'),
          data() {
            return {
              title: config.title || '',
              message: config.message || '',
              confirmText: config.confirmText || 'Sim',
              cancelText: config.cancelText || 'Não',
              confirmColor: config.confirmColor || 'marca-0-l10',
              cancelColor: config.cancelColor || undefined,
              hideCancel: config.hideCancel || false,
            }
          },
          methods: {
            onConfirm() {
              confirmInstance.open = false
              confirmInstance = null
              resolve()
            },
            onCancel() {
              confirmInstance.open = false
              confirmInstance = null
              reject && reject('')
            },
          },
        })
        confirmInstance.open = true
        document.body.appendChild(confirmInstance.$el)
      })
    }
  },
}
